"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LikeAndSince = exports.Separator = exports.Author = exports.Body = exports.Wrapper = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _colors = _interopRequireDefault(require("../../theme/colors"));

var _spacing = _interopRequireDefault(require("../../theme/spacing"));

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    margin-top: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    margin: 0px ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  color: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  && {\n    ", "\n    display: inline;\n    border-radius: 12px;\n    background-color: ", ";\n    padding: ", ";\n  }\n\n  > span {\n    margin-right: ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  & .options-wrapper {\n    visibility: hidden;\n  }\n\n  &:hover > .options-wrapper {\n    visibility: visible;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Wrapper = (0, _styledComponents["default"])(_Grid["default"])(_templateObject());
exports.Wrapper = Wrapper;
var Body = (0, _styledComponents["default"])(_Grid["default"])(_templateObject2(), function (props) {
  return props.theme.fonts.body2;
}, _colors["default"].lychee[300], _spacing["default"][3], _spacing["default"][1]);
exports.Body = Body;

var Author = _styledComponents["default"].span(_templateObject3(), _colors["default"].blueberry[400]);

exports.Author = Author;
var Separator = (0, _styledComponents["default"])(_Typography["default"])(_templateObject4(), _spacing["default"][1]);
exports.Separator = Separator;
var LikeAndSince = (0, _styledComponents["default"])(_Grid["default"])(_templateObject5(), _spacing["default"][1]);
exports.LikeAndSince = LikeAndSince;